//#region imports
import { Directive } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { AppConstants } from 'src/app/app.constants';
//#endregion

@Directive({
  selector: '[appPhoneNumberValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: PhoneNumberValidatorDirective,
    multi: true
  }]
})
export class PhoneNumberValidatorDirective implements Validator {
  //#region methods
  constructor() { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    const validatePhoneNumberPattern = this.validatePhoneNumber(control.value);
    return validatePhoneNumberPattern ? null : { phoneNumberPattern: true };
  }

  validatePhoneNumber(phoneNumber): boolean {
    const phoneNumberRegexPatterns = AppConstants.PhoneNumberRegexPatterns;
    for (const pattern of phoneNumberRegexPatterns) {
      if (pattern.test(phoneNumber)) {
        return true;
      }
    }
    return false;
  }
  //#endregion
}
